// src/services/publicAuthService.js
import axios from 'axios';
import { baseURL } from '../utils/config';

// Instance axios dédiée aux endpoints publics d'authentification
// (pas de token requis : réinitialisation de mot de passe, activation de compte)
const publicApi = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Construit l'URL d'un endpoint propre à un établissement (tenant),
 * identifié par son slug.
 * Ces routes sont déclarées dans backend/api/urls.py, inclus via
 * path("api/<slug:slug>/", include("api.urls")) — donc pas de segment
 * /public/ intermédiaire, le path arrive directement après le slug.
 */
const tenantURL = (slug, path) => `/${slug}/${path}`;

/**
 * Confirme la réinitialisation / définition du mot de passe à partir du
 * lien reçu (par email ou SMS), en utilisant le token fourni.
 * Le slug vient du lien lui-même (généré côté backend depuis
 * user.etablissement), donc INCHANGÉ.
 * POST /api/<slug>/password-reset-confirm/
 */
export const confirmerReinitialisationMotDePasse = async (slug, userId, token, password) => {
  try {
    const response = await publicApi.post(
      tenantURL(slug, 'password-reset-confirm/'),
      { user_id: userId, token, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la confirmation de réinitialisation:", error);
    throw error;
  }
};

/**
 * Déclenche l'envoi d'un lien de réinitialisation de mot de passe
 * (par email ou téléphone).
 * PAS de slug ici : à ce stade, on ne sait pas encore à quel
 * établissement l'utilisateur appartient (exactement comme le login).
 * Le backend retrouve l'établissement à partir du compte trouvé et
 * construit un lien qui contient déjà le bon slug.
 * POST /api/password-reset/  (route globale, hors préfixe /:slug/)
 */
export const demanderReinitialisationMotDePasse = async (emailOuTelephone) => {
  try {
    const response = await publicApi.post(
      '/password-reset/',
      { email_or_telephone: emailOuTelephone }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la demande de réinitialisation:", error);
    throw error;
  }
};

export const publicAuthService = {
  confirmerReinitialisationMotDePasse,
  demanderReinitialisationMotDePasse,
};

export default publicAuthService;